export default function _cloneRegExp(pattern) {
                                  return new RegExp(pattern.source, (pattern.global ? 'g' : '') + (pattern.ignoreCase ? 'i' : '') + (pattern.multiline ? 'm' : '') + (pattern.sticky ? 'y' : '') + (pattern.unicode ? 'u' : ''));
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_cloneRegExp.js
// module id = 8Cfa
// module chunks = 0